<div class="common-modal__container-feedback">
  <!-- Cabecera -->
    <div class="common-status-message__jt-container-alert">
      <i class="lf-icon-close-round-full common-status-message__icon-xl"></i>
        <span class="common-status-message__jt-title"
          [afTranslate]="'role-error-modal.title-modal'"></span>
    </div>
  <!-- Contenedor -->
  <div class="common-modal__content-header-feedback-info">
      <span [innerHTML]="roleErrorModal.infoError"></span>
  </div>
  <div class="advice-modal__container-list">
    <div class="common-modal__content-scroll">
      @for (role of roleErrorModal.roles | afOrderBy:['name']; track $index) {
        <div class="advice-modal__item-list">
          <div class="advice-modal__item-list-header">
            <i class="lf-icon-add-points"></i>
            <div class="advice-modal__inner-item-list-header">
              <span class="advice-modal__item-list-title">{{role.name}}</span>
              <span class="advice-modal__item-list-subtitle">({{role.productName}})</span>
            </div>
          </div>
          @for (client of role.clients | afOrderBy:['name']; track $index) {
            <div class="advice-modal__item-list-info">
              <span class="advice-modal__item-list-info-text">-{{client.name}}</span>
            </div>
          }
        </div>
      }
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    @if (configuration.type === 'notAssignedRoles') {
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title" [afTranslate]="'common.exit'">Salir</span>
      </button>
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title" [afTranslate]="'role-error-modal.manage-roles'">Gestionar roles</span>
      </button>
    }@else {
      <button class="common-button__text"
        (click)="handleAccept()">
        <span class="common-button__text-title" [afTranslate]="'common.ok'">Aceptar</span>
      </button>
    }
  </div>
</div>
